import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Box } from '@mui/material';
import { Profile } from '../sections/@dashboard/device';


export default function DeviceProfile() {
  const location = useLocation();
  const data = location.state.location.state

  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      <Container maxWidth="xxl">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Box state={data} to="/cloud/devices" component={RouterLink}>
            <img width={40} src="../../assets/back-button.gif" alt="verified" style={{marginLeft :4, display: 'inline-block', verticalAlign: 'middle' }} />
          </Box>
          <Typography
            gutterBottom
            variant=""
            component="div"
            sx={{
              color: '#A8A196',
              textAlign: 'left',
              marginLeft: 2,
              paddingBottom: 2,
              fontSize: '1.5rem',
              fontWeight: 'bold',
            }}
          >
            {location.state.location.state.name}
            <Typography variant="" component="div" sx={{ fontSize: 16, color: '#4D4D4D' }}>
              {location.state.location.state.network_name}
            </Typography>
          </Typography>
        </div>
        <Grid container spacing={2}>
          <Profile deviceProfile={location}/>
        </Grid>
      </Container>
    </>
  );
}